module.exports = __webpack_public_path__ + "static/logo-white-c6013d4a7fb9dd173653eefad20bb1e4.svg";